<template>
  <div id="app">
    <router-view :key="key()"></router-view>
    <div v-if="cookieSetting" class="cookie-box">
      <div class="app-box-content">
        <div>
          We use cookies to optimise site functionality and give you the best possible experience.
        </div>
        <div class="app-cookie-button" @click="setting()">Accept Recommended Settings</div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { isMobileDevice } from '@/plugins/deviceDetector';
export default {
  data() {
    return {
      cookieSetting: true,
    };
  },
  async created() {
    let stage = Cookies.get('cookie-stage') || '';
    if (stage) {
      this.cookieSetting = false;
    }

    // 判断是否为移动设备
    const isMobile = isMobileDevice();
    this.$store.commit('setIsMobile', isMobile);

    // 使用预渲染工具类处理API调用
    const settingData = await this.$prerender.skipInPrerender(
      async () => {
        const data = await this.$axios('/base/setting', { isSimple: true });
        return data;
      },
      {
        // 预渲染时的默认设置
        siteName: 'Yours Link',
        seoTitle: 'Professional Real Estate Services',
        seoDescription: 'Find your perfect home with our professional real estate services',
        contactPhone: '',
        contactEmail: '',
        address: '',
      },
    );

    if (settingData) {
      this.$store.commit('setSetting', settingData);
    }
  },
  methods: {
    setting() {
      Cookies.set('cookie-stage', true, { expires: 7 });
      this.cookieSetting = false;
    },
    key() {
      return Math.random();
    },
  },
};
</script>

<style lang="scss">
:root {
  --c-primary: #2b4eb3;
  --c-secondary: #f5d569;
  --c-grey: #8a95ac;
  --c-bg: #f2f2f2;
  --c-text: #0f1d3d;
}

.c-field-required::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}

section {
  box-sizing: border-box;
}

// ========================= MEDIA QUERY BELOW ===================================

@media only screen and (min-width: 1920px) {
  html {
    font-size: 20px;
  }
}

@media only screen and (max-width: 1920px) and (min-width: 1680px) {
  html {
    font-size: 18px;
  }
}

@media only screen and (max-width: 1680px) and (min-width: 1440px) {
  html {
    font-size: 16px;
  }
}

@media only screen and (max-width: 1440px) and (min-width: 1366px) {
  html {
    font-size: 16px;
  }
}

@media only screen and (max-width: 1366px) and (min-width: 1280px) {
  html {
    font-size: 14px;
  }
}

@media only screen and (max-width: 1280px) and (min-width: 1024px) {
  html {
    font-size: 12px;
  }
}

@media only screen and (max-width: 1024px) {
  html {
    font-size: 2.666667vw;
  }
}

.cookie-box {
  width: 100%;
  height: 50px;
  position: fixed;
  font-size: 16px;
  z-index: 99999;
  background: rgba($color: #eee, $alpha: 0.8);
  left: 0;
  bottom: 0;
}

.app-box-content {
  width: 100%;
  color: #8a95ac;
  display: flex;
  justify-content: space-between;
  line-height: 50px;
  padding: 0 60px;
}

.app-cookie-button {
  font-size: 16px;
  height: 36px;
  padding: 0 20px;
  margin-top: 9px;
  line-height: 36px;
  cursor: pointer;
  background-color: #2b4eb3;
  color: #fff;
}

@media only screen and (max-width: 1024px) {
  .cookie-box {
    display: none;
  }
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--c-primary);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.collaspe-enter-active,
.collaspe-leave-active {
  transition: all 0.5s ease-in-out;
  max-height: 9999px;
}

.collaspe-enter, .collaspe-leave-to /* .collaspe-leave-active below version 2.1.8 */ {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
}

.mapboxgl-ctrl-attrib-inner,
.mapboxgl-ctrl-logo {
  display: none !important;
}

.el-input__icon {
  line-height: 1;
}
</style>
